const routes = {
  getAuctionHouses: 'auctionHouses',
  createAuctionHouse: 'auctionHouses/add',
  updateAuctionHouse: 'auctionHouses/update',
  deleteAuctionHouse: 'auctionHouses/delete',
};

export default routes